<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="showWarningPopup"
      class="rfp-rr-write-review-warning-240-or review-popup full-review-active selectPage-in-drop-down"
      data-popup="review-popup"
      style="display: block"
    >
      <div class="rfp-rr-write-review-warning-241-or review-popup-close" @click="closePopup">
        {{ popupClose }}
      </div>
      <div id="success-message" class="rfp-rr-write-review-warning-242-or popup-inner">
        <div
          class="rfp-rr-write-review-warning-243-or message-icon success"
          :class="{ 'image--display': warningIcon === '' }"
        >
          <img :src="warningIcon" :style="{ width: '100%' }" :alt="warningIconAltText" />
        </div>
        <div class="rfp-rr-write-review-warning-244-or message" v-html="warningText"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-ratings-write-review-warning',
  props: {
    warningIcon: {
      type: String,
      required: true,
    },
    warningText: {
      type: String,
      required: true,
    },
    warningIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showWarningPopup: false,
      activeSlider: false,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('show-review-warning', () => {
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
      this.showWarningPopup = true;
    });
  },
  methods: {
    closePopup() {
      this.activeSlider = false;
      this.showWarningPopup = false;
      document.body.classList.remove('rare-custom-body-class');
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
